import { Component, OnInit, ViewChild } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertMessageService } from '../../services/alert-message.service';
import { LanguageService } from '../../services/language.service';
import { ProfileService } from '../../services/profile.service';
import { CompanyInfoService } from 'src/app/services/company-info.service';
import { RequestShippingPaymentService } from 'src/app/services/request-shipping-payment.service';
import {
  FormControl,
  FormGroup,
  FormBuilder,
  Validators,
} from '@angular/forms';
import { MessagesService } from 'src/app/services/messages.service';
import { DashboardService } from 'src/app/services/dashboard.service';
import { RegisterPackageService } from 'src/app/services/register-package.service';
import flatpickr from '../../../assets/flatpickr';
import { Spanish } from '../../../assets/flatpickr/dist/l10n/es';
import { DashboardAdminService } from 'src/app/services/dashboard-admin.service';
import { TranslateService } from '@ngx-translate/core';
import { TranslateAgencyOperatorService } from 'src/app/services/translate-agency-operator.service';
import { ChartOptions, ChartType, ChartDataSets } from 'chart.js';
import { SelectionModel } from '@angular/cdk/collections';
import { AgencyService } from 'src/app/services/agency.service';
import { MatTableDataSource, MatPaginator, PageEvent, MatSort } from '@angular/material';
import { HostListener } from '@angular/core';
import { FileService } from 'src/app/services/file.service';

@Component({
  selector: 'app-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss'],
})
export class HomePageComponent implements OnInit {
  LOCKER_USER_CODE: String = 'DCV';
  ADMIN_USER_CODE: String = 'ADM';
  OPERATOR_USER_CODE: String = 'OPB';
  ADMIN_LOCKER_USER_CODE: String = 'ACV';
  OPERATOR_WAREHOUSE_USER_CODE: String = 'OBCV';
  OPERATOR_AGENCY: String = 'OPAG';
  DESTINY_COUNTRY_OPERATOR: String = 'OPD';
  OPERATOR_ACCOUNTING: String = 'OPC';
  INFO_GUIDES_AGENCY: String = 'IGA';
  //
  firstname: string;
  lastname: string;
  avatarURL: string;
  numLocker: String;
  roles: Array<String> = [];
  //
  newPhoto: any;
  userStatistics: any;
  adminStatistics: any;
  //
  monday: any;
  company: any = {};
  sendMessageAdminForm: FormGroup;
  messages: Array<any> = [];
  dashboard: any = {};
  agencyOperator: any = {};

  dashboardAdminWarehouse: any = {};
  openId = -1;
  currentMessage: String;
  //
  photoName = '';
  pictureForm: FormGroup;
  // ---
  foundInfoOfUsers: Array<any>;
  selectedUser: any = {};
  selectedUserTemp: any;
  searchUserForm: FormGroup;
  prueba: any;

  // Operario de cantabilidad
  loading = false;
  generateReportForm: FormGroup;
  selectionCollectedAgencies = new SelectionModel<any>(true, []);
  agenciesToModal: any;
  dataSource: any;
  urlExcel: any;
  urlPDF: any;
  displayedColumns: string[] = [
    'guideNumber',
    'receiver',
    'tax',
    'freight',
    'insurance',
    'total',
    'currentStatus',
  ];

  displayedColumnsAgency: string[] = [
    'guideNumber',
    'guideDate',
    'guideWeight',
    'receiver',
    'sender',
    'consolidated',
    'currentStatus',
  ];

  displayedColumnsNovelties: string[] = [
    'guideNumberNovelty',
    'noveltyDate',
    'noveltyNote',
    'currentGuideStatus'
  ];

  selectedAgencies: Array<any>;
  guides: any;
  servicesAgency = [];
  countries: Array<any>;
  dataModal: any;
  guidesAgencyArray: Array<any>;
  guidesAgencySource: any;
  noveltiesGuidesAgencySource: any;

  //For pagination
  public pageSize = 15;
  public currentPage = 0;
  public totalSize = 0;
  pageSizeOptions: number[] = [15];
  pageEvent: PageEvent;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  // Screen Size
  screenHeight: number;
  screenWidth: number;
  packageMovementArray: Array<any>;
  packageMovement: any;
  packagePictures: any;
  //dashboard admin
  labelAgencies: string = '';
  labelServices: string = '';
  labelMoneyDayBefore: string = '';
  labelGuidesDayBefore: string = '';
  labelMoneyWeekBefore: string = '';
  labelOpenConsolidated: string = '';
  labelConsolidatedWeekBefore: string = '';
  labelTotalConsolidated: string = '';
  dashboardAdminDataStatic: any = {};
  dashboardAdminCasillero: any = {};
  dashboardAdminDataYesterday: any = {};
  dashboardAdminDataLastWeek: any = {};
  consolidatedSevenDaysAgo: any;
  infoDaysWeek: any;
  infoOfMonths: any;
  single: any[];
  single2: any[];
  single3: any[];
  single4: any[];
  view: any[] = [600, 300];
  view2: any[] = [400, 150];
  view3: any[] = [270, 170];
  view4: any[] = [500, 200];
  view5: any[] = [650, 430];
  view7: any[] = [280, 200];
  single5: any[];
  single6: any[];
  single7: any[];
  view6: any[] = [260, 110];

  // options  pie chart
  gradient = true;
  showLegend = false;
  showLabels = true;
  isDoughnut = false;
  legendPosition = 'below';
  colorText = '#FF6600';

  xcolor = getComputedStyle(document.body);

  cardColor = '#232837';

  colorScheme: any;

  multi: any[];


  // options vertical bar
  showXAxis = true;
  showYAxis = true;
  gradientBar = false;
  showXAxisLabel = false;
  xAxisLabel = 'Dias ';
  showYAxisLabel = true;
  yAxisLabel = 'Paquetes Ingresados';

  // option  line gauge
  value1: number;
  value2: number;
  value3: number;
  labelUserLockers = '';
  labelPreALertMonth = '';
  labelPackagesMonth = '';
  // Chart ======================

  public barChartOptions: ChartOptions = {
    responsive: true,
    // We use these empty structures as placeholders for dynamic theming.
    scales: { xAxes: [{}], yAxes: [{}] },
  };



  public handlePage(e: any) {
    this.currentPage = e.pageIndex;
    this.pageSize = e.pageSize;
    this.iterator();
  }

  private iterator() {
    if (this.roles.includes(this.OPERATOR_AGENCY) || this.roles.includes(this.OPERATOR_WAREHOUSE_USER_CODE)) {
      const start = this.currentPage * this.pageSize;

      this.agencyService.guidesOfDashboard(start).subscribe(result => {
        if (result['status']) {
          this.guidesAgencyArray = result['guides'];
          this.guidesAgencySource = new MatTableDataSource(this.guidesAgencyArray);
          this.totalSize = result['totalGuides'];
        } else {
          this.alertMessageService.showInfoMessage(this.languageService.getCurrentLanguage(), result['code']);
        }
      });
    }
  }

  getGuidesAgency() {
    if (this.roles.includes(this.OPERATOR_AGENCY) || this.roles.includes(this.OPERATOR_WAREHOUSE_USER_CODE)) {
      this.agencyService.guidesOfDashboard(0).subscribe((result: any) => {
        if (result.status) {
          this.guidesAgencyArray = result.guides;
          this.guidesAgencySource = new MatTableDataSource(this.guidesAgencyArray);
          this.iterator();
          this.totalSize = result.totalGuides;
        } else {
          this.alertMessageService.showInfoMessage(this.languageService.getCurrentLanguage(), result.code);
        }
      });
    }
  }

  getGuidesWithNoveltiesAgency() {
    if (this.roles.includes(this.OPERATOR_AGENCY) || this.roles.includes(this.OPERATOR_WAREHOUSE_USER_CODE)) {
      this.agencyService.noveltiesGuidesOfDashboard().subscribe((result: any) => {
        if (result.status) {
          const novelties = result.guides ? result.guides : [];
          this.noveltiesGuidesAgencySource = new MatTableDataSource(novelties);
        } else {
          this.alertMessageService.showInfoMessage(this.languageService.getCurrentLanguage(), result.code);
        }
      });
    }
  }

  public dataMonth: Array<any> = [
    {
      name: 'Germany',
      value: 8940000,
    },
    {
      name: 'USA',
      value: 5000000,
    },
  ];
  data2 = [
    {
      valor: 8940000,
    },
    {
      valor: 5000000,
    }
  ];

  dataCountry = [
    {
      name: 400,
    },
    {
      name: 100,
    }
  ];

  public barChartData2: ChartDataSets[] = [
    { data: this.data2.map((x) => x.valor), label: 'Series A' },
  ];

  public barChartLabels = [
    '2006',
    '2007',
    '2008',
    '2009',
    '2010',
    '2011',
    '2012',
  ];
  public barChartType: ChartType = 'line';
  public barChartLegend = true;
  data = [
    {
      valor: 65,
    },
    {
      valor: 59,
    },
    {
      valor: 80,
    },
    {
      valor: 81,
    },
    {
      valor: 56,
    },
    {
      valor: 55,
    },
    {
      valor: 40,
    },
  ];
  public barChartData: ChartDataSets[] = [
    { data: this.data.map((x) => x.valor), label: 'Series A' },
    { data: [28, 48, 40, 19, 86, 27, 90], label: 'Series B' },
  ];

  chartOptions = {
    scaleShowVerticalLines: false,
    responsive: true,
    scales: {
      yAxes: [
        {
          stacked: false,
          gridLines: {
            display: false,
          },
        },
      ],
      xAxes: [
        {
          stacked: false,
          gridLines: {
            display: false,
          },
        },
      ],
    },
  };
  public chartLabels = [];
  public chartType: ChartType = 'bar';
  public chartLegend = true;
  // public chartDataWeight;
  public chartDataWeight: ChartDataSets[] = [
    { data: [1066, 0, 0, 0, 0], label: 'Peso' },
    { data: [28, 48, 40, 19, 86], label: 'Series B' },
  ];
  public chartDataEarning;
  public chartDataQuantity;
  public months;
  public labelWeight;
  public labelEarnings;
  public labelQuantity;
  public english;
  index = 0;
  indexAccounting = 0;
  amountCharts = 3;
  // end Chart ======================

  // MouseOver graphics
  public mouseOverGraphic = false;
  public mouseOverGraphicAccounting = false;

  // Messages modal
  @ViewChild('modalMessageNotification') messageModal;

  constructor(
    private formBuilder: FormBuilder,
    private modalService: NgbModal,
    private alertMessageService: AlertMessageService,
    private languageService: LanguageService,
    private _formBuilder: FormBuilder,
    private profileService: ProfileService,
    private agencyService: AgencyService,
    private companyService: CompanyInfoService,
    private requestShippingPaymentService: RequestShippingPaymentService,
    private messageService: MessagesService,
    private dashboardService: DashboardService,
    private dashboardAdminService: DashboardAdminService,
    private registerPackageService: RegisterPackageService,
    private translate: TranslateService,
    private translateAgencyOpertator: TranslateAgencyOperatorService,
    private archivoService: FileService,
  ) {
    this.value1 = 1;
    this.value2 = 1;
    this.value3 = 1;
    this.dashboardService.getInfoAgency().subscribe((result) => {
      this.agencyOperator = result;
      // if (this.agencyOperator['status']) {
      //   this.showMonthsLabels(this.languageService.getCurrentLanguage());
      // }
    });
    this.english = false;
    this.loadUserInfo();
    this.getLanguageLabelsDashboard(this.languageService.getCurrentLanguage());
    this.sendMessageAdminForm = new FormGroup({
      message: new FormControl('', Validators.required),
      sendTo: new FormControl('DCV', Validators.required),
      subject: new FormControl(''),
      user: new FormControl(''),
      picker1: new FormControl('', Validators.required),
      picker2: new FormControl('', Validators.required),
    });
    this.dashboardService.getWarehouseDashboard().subscribe((result) => {
      this.dashboard = result;
    });
    this.dashboardAdminService
      .getAdminWarehouseDashboard()
      .subscribe((result) => {
        this.dashboardAdminWarehouse = result;
      });
    this.initFormSearchUser();
    this.pictureForm = new FormGroup({
      purchaseReceipt: new FormControl(),
    });
    this.getInfo();
    this.getScreenSize();
    this.getDataDashboard();
    this.getInfoUserLocker();
  }

  @HostListener('window:resize', ['$event'])
  getScreenSize(event?) {
    this.screenHeight = window.innerHeight;
    this.screenWidth = window.innerWidth;
    if (this.screenWidth >= 1440) {
      this.view6 = [260, 110];
      this.view = [600, 300];
    }
    if (this.screenWidth < 1600 && this.screenWidth >= 1440) {
      this.view = [400, 250];
    }
    if (this.screenWidth < 1440 && this.screenWidth >= 980) {
      this.view6 = [200, 110];
      this.view = [300, 250];
    }
    if (this.screenWidth < 980) {
      this.view6 = [350, 110];
      this.view = [650, 300];
    }
  }
  ngOnInit() {
    this.getCountries();
    this.getAgenciesToModal();
    this.listServices();
    this.setServicies();
    this.validateForm();
    if (this.languageService.getCurrentLanguage() === 'es') {
      flatpickr('.flatpickr', {
        locale: Spanish,
        dateFormat: 'Y-m-d',
      });
    } else {
      flatpickr('.flatpickr', {});
    }

    setInterval(() => {
      if (!this.mouseOverGraphic) {
        this.nextChart();
      }
    }, 3000);
    setInterval(() => {
      if (!this.mouseOverGraphicAccounting) {
        this.nextChartAccounting();
      }
    }, 3000);

    this.generateReportForm.controls['selectPaid'].setValue('0');
    this.generateReportForm.controls['selectService'].setValue('0');
    this.guidesAgencySource = new MatTableDataSource([]);
    this.getGuidesAgency();
    this.getGuidesWithNoveltiesAgency();
    this.colorScheme = this.getColorDashboard();
  }

  // Form de Repotes para contabilidad

  validateForm() {
    this.generateReportForm = this._formBuilder.group({
      picker1: ['', Validators.required],
      picker2: ['', Validators.required],
      selectService: [''],
      selectPaid: [''],
      country: [''],
    });
  }

  setServicies() {
    this.agencyService.getServicesByAgencyAuto().subscribe((result) => {
      if (result['status']) {
        this.servicesAgency = result['services'];
      }
    });
  }

  listServices() {
    this.agencyService.listServices().subscribe((result) => {
      if (result['status']) {
        this.servicesAgency = result['services'];
      }
    });
  }
  getCountries() {
    const language = this.languageService.getCurrentLanguage();
    this.requestShippingPaymentService.getCountries().subscribe(
      (result) => {
        if (result['status'] === true) {
          this.countries = result['countries'];
        }
      },
      (error) => {
        const messageCode = 'CE';
        this.alertMessageService.showErrorMessage(language, messageCode);
      }
    );
  }

  getAgenciesToModal() {
    this.agencyService.getAllAgencies().subscribe((result) => {
      if (result['status']) {
        this.agenciesToModal = result['agencies'];
      }
    });
  }

  addData(modalReport) {
    this.loading = true;
    const data = {
      from: this.generateReportForm.controls['picker1'].value.toString(),
      to: this.generateReportForm.controls['picker2'].value.toString(),
      typeService: this.generateReportForm.controls['selectService'].value,
      typePaid: this.generateReportForm.controls['selectPaid'].value,
      date: new Date().toString(),
      agencies: this.selectionCollectedAgencies.selected,
      country: this.generateReportForm.controls['country'].value,
    };

    this.agencyService.reportAgencies(data).subscribe(
      (result) => {
        const messageCode = result['code'];
        if (result['status']) {
          this.loading = false;
          this.guides = result['guides'];
          this.urlExcel = result['urlExcel'];
          this.urlPDF = result['urlPDF'];
          this.dataSource = new MatTableDataSource(this.guides);
          this.openModalChangePhoto(modalReport);
        }
      },
      (error) => {
        const messageCode = 'CE';
      }
    );
  }

  agenciesSelected() {
    if (this.selectionCollectedAgencies.selected.length < 1) {
      return false;
    }
    return true;
  }

  isAllSelected() {
    const numSelected = this.selectionCollectedAgencies.selected.length;
    const numRows = this.agenciesToModal.length;
    return numSelected === numRows;
  }

  masterToggle() {
    this.isAllSelected()
      ? this.selectionCollectedAgencies.clear()
      : this.agenciesToModal.forEach((agency) =>
        this.selectionCollectedAgencies.select(agency.id)
      );
  }

  submitAgencies() {
    this.selectedAgencies = new Array<any>();
    this.selectionCollectedAgencies['selected'].forEach((selected) => {
      this.selectedAgencies.push(selected);
    });
  }

  openModal(modal, data?) {
    this.modalService.open(modal, { size: 'lg' });
    this.dataModal = data;
  }

  // Charts Methods

  showMonthsLabels(language) {
    this.chartLabels = [];
    this.agencyOperator.graphic
      .map((x) => x.month)
      .reverse()
      .forEach((element) => {
        this.chartLabels.push(
          this.dashboardService.showMonth(language, element)
        );
      });
    //  Traduccion del label de la gráfica
    this.translate.stream('newPreAlertPage.packageWeight').subscribe((x) => {
      this.labelWeight = x;
      this.chartDataWeight = [
        {
          data: this.agencyOperator['graphic']
            .map((y) => y.weightTotal)
            .reverse(),
          label: this.labelWeight,
        },
      ];
    });
    this.translate.stream('newPreAlertPage.packageQuantity').subscribe((x) => {
      this.labelQuantity = x;
      this.chartDataQuantity = [
        {
          data: this.agencyOperator['graphic'].map((y) => y.quantity).reverse(),
          label: this.labelQuantity,
        },
      ];
    });
    this.translate.stream('reportArea.earnings').subscribe((x) => {
      this.labelEarnings = x;
      this.chartDataEarning = [
        {
          data: this.agencyOperator['graphic']
            .map((y) => y.earningsTotal)
            .reverse(),
          label: this.labelEarnings,
        },
      ];
    });
  }

  prevChart() {
    this.index = this.index-- === 0 ? this.amountCharts - 1 : this.index--;
  }

  nextChart() {
    this.index = this.index++ === this.amountCharts - 1 ? 0 : this.index++;
  }

  prevChartAccounting() {
    this.indexAccounting =
      this.indexAccounting-- === 0
        ? this.amountCharts - 1
        : this.indexAccounting--;
  }

  nextChartAccounting() {
    this.indexAccounting =
      this.indexAccounting++ === this.amountCharts - 1
        ? 0
        : this.indexAccounting++;
  }
  // ============

  loadUserInfo() {
    const token = localStorage.getItem('currentUser');
    const helper = new JwtHelperService();
    const decodedToken = helper.decodeToken(token);
    this.firstname = decodedToken.firstname;
    this.lastname = decodedToken.lastname;
    this.avatarURL = localStorage.getItem('avatarURL');
    this.numLocker = decodedToken.numlocker;
    const tokenInfo = localStorage.getItem('tokenInfo');
    const helperInfo = new JwtHelperService();
    const decodedTokenInfo = helperInfo.decodeToken(tokenInfo);
    this.roles = decodedTokenInfo.roles;
    if (
      !this.avatarURL ||
      this.avatarURL === undefined ||
      this.avatarURL === 'undefined' ||
      this.avatarURL == null
    ) {
      // tslint:disable-next-line: max-line-length
      this.avatarURL = 'data:image/jpeg;base64,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';
    }
    this.getMessage();
  }

  openModalChangePhoto(modal) {
    this.modalService.open(modal, { size: 'lg' });
  }

  changePhoto() {
    const language = this.languageService.getCurrentLanguage();
    const formData = new FormData();
    formData.append('avatar', this.newPhoto); // --->File

    this.profileService.changeProfilePhoto(formData).subscribe(
      (result) => {
        const messageCode = result['code'];
        if (result['status'] === true) {
          this.alertMessageService.showSuccessMessage(language, messageCode);
          const url = result['url'];
          this.avatarURL = url;
          localStorage.setItem('avatarURL', url);
          this.photoName = '';
          this.newPhoto = null;
          this.pictureForm.patchValue({ purchaseReceipt: null });
        } else {
          this.alertMessageService.showErrorMessage(language, messageCode);
        }
      },
      (error) => {
        const messageCode = 'CE';
        this.alertMessageService.showErrorMessage(language, messageCode);
      }
    );
  }

  receiptLoad($event) {
    this.newPhoto = null;
    const maxSizeFile = 5000000;
    const language = this.languageService.getCurrentLanguage();

    if ($event.target.files.length === 1) {
      const file = $event.target.files[0];
      this.photoName = file.name;
      if (file.size > maxSizeFile) {
        this.alertMessageService.showErrorMessage(language, 'EFT');
      } else if (!['image/jpeg', 'image/png'].includes(file.type)) {
        this.alertMessageService.showErrorMessage(language, 'TPF');
      } else {
        this.newPhoto = file;
      }
    }
  }

  getUserStatistics() {
    this.languageService.getTranslateOf('home.changePhoto');

    const language = this.languageService.getCurrentLanguage();
    this.profileService.getUserStatistics().subscribe(
      (result) => {
        const messageCode = result['code'];
        if (result['status'] === true) {
          this.userStatistics = result;
        } else {
        }
      },
      (error) => {
        const messageCode = 'CE';
        this.alertMessageService.showErrorMessage(language, messageCode);
      }
    );
  }

  getAdminStatics() {
    const language = this.languageService.getCurrentLanguage();
    this.profileService.getAdminDashboard().subscribe(
      (result) => {
        const messageCode = result['code'];
        if (result['status'] === true) {
          this.adminStatistics = result;
        } else {
        }
      },
      (error) => {
        const messageCode = 'CE';
        this.alertMessageService.showErrorMessage(language, messageCode);
      }
    );
  }

  getCompanyInfo() {
    this.companyService.getCompanyInfo().subscribe((data) => {
      this.company = data['company'];
      if (this.company && this.roles.includes('DCV')) {
        this.getAddress(this.company.country);
      }
    });
  }

  getAddress(countryId) {
    const language = this.languageService.getCurrentLanguage();
    this.requestShippingPaymentService.getStatesByCountry(countryId).subscribe(
      (result) => {
        if (result['status'] === true) {
          this.company.stateName = result['states'].filter(
            (elem) => elem.id === this.company.state
          )[0].statename;
        }
      },
      (error) => {
        const messageCode = 'CE';
        this.alertMessageService.showErrorMessage(language, messageCode);
      }
    );
    this.requestShippingPaymentService.getCountries().subscribe(
      (result) => {
        if (result['status'] === true) {
          this.company.countryName = result['countries'].filter(
            (elem) => elem.id === this.company.country
          )[0].countryname;
        }
      },
      (error) => {
        const messageCode = 'CE';
        this.alertMessageService.showErrorMessage(language, messageCode);
      }
    );
    this.requestShippingPaymentService.getStatesByCountry(countryId).subscribe(
      (result) => {
        if (result['status'] === true) {
          this.company.stateName = result['states'].filter(
            (elem) => elem.id === this.company.state
          )[0].statename;
        }
      },
      (error) => {
        const messageCode = 'CE';
        this.alertMessageService.showErrorMessage(language, messageCode);
      }
    );
    this.requestShippingPaymentService
      .getCitiesByState(this.company.state)
      .subscribe(
        (result) => {
          if (result['status'] === true) {
            this.company.cityName = result['cities'].filter(
              (elem) => elem.id === this.company.city
            )[0].cityname;
          }
        },
        (error) => {
          const messageCode = 'CE';
          this.alertMessageService.showErrorMessage(language, messageCode);
        }
      );
  }

  async getInfo() {
    this.getUserStatistics();
    this.getCompanyInfo();
    this.getAdminStatics();
  }

  sendMessage() {
    const language = this.languageService.getCurrentLanguage();
    const data = {
      message: this.sendMessageAdminForm.value['message'],
      to_role_name: this.sendMessageAdminForm.value['sendTo'],
      subject: this.sendMessageAdminForm.value['subject'],
      activationDate: this.sendMessageAdminForm.value['picker2'],
      expirationDate: this.sendMessageAdminForm.value['picker'],
      to_user_id: this.selectedUser.id,
    };
    if (data.to_role_name === 'LUM' && this.selectedUser.id != null && !this.loading) {
      this.loading = true;
      this.messageService.sendMessageToUser(data).subscribe((result) => {
        this.loading = false;
        const messageCode = result['code'];
        if (result['status'] === true) {
          this.alertMessageService.showSuccessMessage(language, messageCode);
          this.sendMessageAdminForm.reset();
        } else {
          this.alertMessageService.showErrorMessage(language, messageCode);
        }
      },
        (error) => {
          this.loading = false;
          const messageCode = 'CE';
          this.alertMessageService.showErrorMessage(language, messageCode);
        }
      );
    } else {
      this.messageService.sendMessageToRol(data).subscribe(
        (result) => {
          const messageCode = result['code'];
          if (result['status'] === true) {
            this.alertMessageService.showSuccessMessage(language, messageCode);
            this.sendMessageAdminForm.reset();
          } else {
            this.alertMessageService.showErrorMessage(language, messageCode);
          }
        },
        (error) => {
          const messageCode = 'CE';
          this.alertMessageService.showErrorMessage(language, messageCode);
        }
      );
    }
  }

  getMessage() {
    const language = this.languageService.getCurrentLanguage();
    this.messageService.getMessage().subscribe(
      (result) => {
        if (result['messages']) {
          this.messages = result['messages'];
          const pendingMessage = this.messages.find((m) => !m.seen);
          if (pendingMessage) {
            const index = this.messages.indexOf(pendingMessage);
            this.showMessage(index, this.messageModal);
          }
        }
      },
      (error) => {
        const messageCode = 'CE';
        this.alertMessageService.showErrorMessage(language, messageCode);
      }
    );
  }

  openMessage(message, i) {
    this.openId = i;
    const data = {
      message_id: message.id,
    };
    this.messageService.readMessage(data).subscribe((result) => {
      this.getMessage();
    });
  }

  showMessage(i, modal) {
    if (this.openId === i) {
      this.openId = -1;
    } else {
      this.openId = i;
      this.currentMessage = this.messages[this.openId];
      const x = this.modalService.open(modal, {
        backdrop: 'static',
        keyboard: false,
        size: 'lg',
      });
      document.getElementById('message').innerHTML = this.currentMessage['message'];
      const s_height = document.getElementById('message').scrollHeight;
      document.getElementById('message').style.height = (s_height * 2) + 'px';

      x.result.then(() => {
        const message = this.messages[i];
        this.openMessage(message, i);
      });
    }
  }

  openModalSearchUser(modal) {
    const x = this.modalService.open(modal, { size: 'lg' });
    // ----EVENTO QUE SE ACTIVA CUANDO SE CIERRA EL MODAL
    x.result.then(
      () => {
        this.selectedUserTemp = null;
        this.foundInfoOfUsers = [];
      },
      () => {
        this.selectedUserTemp = null;
        this.foundInfoOfUsers = [];
      }
    );
  }

  searchUser() {
    const data = this.searchUserForm.value;
    const language = this.languageService.getCurrentLanguage();

    this.registerPackageService.searchUser(data).subscribe(
      (result) => {
        this.foundInfoOfUsers = result['users'];
      },
      (error) => {
        const messageCode = 'CE';
        this.alertMessageService.showErrorMessage(language, messageCode);
      }
    );
  }

  initFormSearchUser() {
    this.searchUserForm = this.formBuilder.group({
      value: ['', Validators.compose([])],
    });
  }

  //dashboard admin
  onSelect(data): void {
  }

  onActivate(data): void {
  }

  onDeactivate(data): void {
  }

  /**
   * metodo encargado de hacer una gran part de la configuracion de los datos
   * traidos pra el dashboard
   */
  configData() {
    this.value1 = this.dashboardAdminDataStatic.lockerUsers ? this.dashboardAdminDataStatic.lockerUsers : 1;
    this.value2 = this.dashboardAdminCasillero.preAlerts ? this.dashboardAdminCasillero.preAlerts : 1;
    this.value3 = this.dashboardAdminCasillero.packages ? this.dashboardAdminCasillero.packages : 1;
    this.single = this.infoOfMonths ? this.infoOfMonths : [
      {
        name: 'Agosto',
        value: 800
      },
      {
        name: 'Septiembre',
        value: 1000
      },
      {
        name: 'Octubre',
        value: 1200
      },
      {
        name: 'Noviembre',
        value: 900
      },
      {
        name: 'Diciembre',
        value: 1800
      },
      {
        name: 'Enero',
        value: 600
      }
    ];
    this.single2 = [
      {
        name: this.labelAgencies,
        value: this.dashboardAdminDataStatic.agencies ? `${this.dashboardAdminDataStatic.agencies}` : 0
      },
      {
        name: this.labelServices,
        value: this.dashboardAdminDataStatic.services ? `${this.dashboardAdminDataStatic.services}` : 0
      },
    ];

    this.single3 = [
      {
        name: this.labelMoneyWeekBefore,
        value: this.dashboardAdminDataLastWeek.totalMaster ? `${this.dashboardAdminDataLastWeek.totalMaster}` : 0
      },
    ];
    this.single4 = [
      {
        name: this.labelOpenConsolidated,
        value: this.dashboardAdminDataStatic.openConsolidated ? `${this.dashboardAdminDataStatic.openConsolidated}` : 0
      },
      {
        name: this.labelConsolidatedWeekBefore,
        value: this.consolidatedSevenDaysAgo ? this.consolidatedSevenDaysAgo : 0
      }
    ];
    this.single7 = [
      {
        name: this.labelTotalConsolidated,
        value: this.dashboardAdminDataStatic.consolidated ? `${this.dashboardAdminDataStatic.consolidated}` : 0
      },
    ];

    this.single5 = this.infoDaysWeek ? this.infoDaysWeek : [
      {
        name: 'martes',
        value: 150
      },
      {
        name: this.monday,
        value: 170
      },
      {
        name: 'Miercoles',
        value: 200
      },
      {
        name: 'Jueves',
        value: 150
      },
      {
        name: 'Viernes',
        value: 220
      },
      {
        name: 'Sabado',
        value: 185
      },
      {
        name: 'Domingo',
        value: 80
      },
    ];
    this.single6 = [
      {
        name: this.labelMoneyDayBefore,
        value: this.dashboardAdminDataYesterday.totalMaster ? `${this.dashboardAdminDataYesterday.totalMaster}` : 0
      },
      {
        name: this.labelGuidesDayBefore,
        value: this.dashboardAdminDataYesterday.totalBox ? `${this.dashboardAdminDataYesterday.totalBox}` : 0
      },
    ];
  }

  /**
   * obtenemos el  esquema de colores  que se va a utilizar para los graficos del
   * @returns
   */
  getColorDashboard() {
    const colorDashboard = {};
    const auxtheme = this.xcolor.getPropertyValue('--theme-domain');
    colorDashboard['domain'] = auxtheme.split(',');
    return colorDashboard;
  }

  /**
   * metodo encargado de recibir la informacion del backend para
   * el dashboard
   */
  getDataDashboard() {
    this.dashboardAdminService.getAdminDashboardHome().subscribe(result => {
      if (result['status']) {
        this.dashboardAdminDataStatic = result['data'];
        this.dashboardAdminCasillero = result['dataCasillero'];
        this.dashboardAdminDataYesterday = result['yesterday'];
        this.dashboardAdminDataLastWeek = result['lastweek'];
        this.consolidatedSevenDaysAgo = result['consolidatedSevenDaysAgo'];
        const tempInfoMonths = result['infoMonths'];
        this.getLabelsMonths(tempInfoMonths, this.languageService.getCurrentLanguage());
        const tempInfoDays = result['infoDays'];
        this.getLabelsDays(tempInfoDays, this.languageService.getCurrentLanguage());
        this.configData();
      } else {
        this.loading = false;
      }
    }, error => {
      this.loading = false;
    });
  }

  /**
   * Metodo encargado de hacer las traducciones de los labels ngx charts
   * @param language
   */
  getLanguageLabelsDashboard(language) {
    this.languageService.getTranslateOf('createAgency.agencies').subscribe((result) => {
      this.labelAgencies = result;
    });
    this.languageService.getTranslateOf('home.services').subscribe((result) => {
      this.labelServices = result;
    });
    this.languageService.getTranslateOf('listAgency.users').subscribe((result) => {
      this.labelUserLockers = result;
    });
    this.languageService.getTranslateOf('home.preAlertCurrentMonth').subscribe((result) => {
      this.labelPreALertMonth = result;
    });
    this.languageService.getTranslateOf('home.packageCurrentMonth').subscribe((result) => {
      this.labelPackagesMonth = result;
    });
    this.languageService.getTranslateOf('home.lastSevenDaysConsolidated').subscribe((result) => {
      this.labelConsolidatedWeekBefore = result;
    });
    this.languageService.getTranslateOf('consolidated.withoutConsolidated').subscribe((result) => {
      this.labelOpenConsolidated = result;
    });
    this.languageService.getTranslateOf('home.totalConsolidated').subscribe((result) => {
      this.labelTotalConsolidated = result;
    });
    this.languageService.getTranslateOf('home.moneyFromDayBefore').subscribe((result) => {
      this.labelMoneyDayBefore = result;
    });
    this.languageService.getTranslateOf('home.guidesDayBefore').subscribe((result) => {
      this.labelGuidesDayBefore = result;
    });
    this.languageService.getTranslateOf('home.moneyLastSevenDays').subscribe((result) => {
      this.labelMoneyWeekBefore = result;
    });
    this.languageService.getTranslateOf('home.days').subscribe((result) => {
      this.xAxisLabel = result;
    });
    this.languageService.getTranslateOf('consolidatePackages.createGuides').subscribe((result) => {
      this.yAxisLabel = result;
    });
  }

  /**
   * metodo utilizado para  llamar un serivivio y se
   * obtengan  las traduccions de una cantidad de meses
   * @param data  array de json de meses a traducir
   * @param language  language actual al que se va a traducir
   */
  getLabelsMonths(data, language) {
    const aux = [];
    data.map(element => {
      aux.push({
        name: this.dashboardService.showMonth(language, element.name),
        value: element.value
      });
    });
    this.infoOfMonths = aux;
  }

  /**
   * metodo utilizado para  llamar un serivivio y se
   * obtengan  las traduccions de una cantidad de dias
   * @param data  array de json de meses a traducir
   * @param language language actual al que se va a traducir
   */
  getLabelsDays(data, language) {
    const aux = [];
    data.map(element => {
      aux.push({
        'name': this.dashboardService.showDays(language, element.name),
        'value': element.value
      });
    });
    this.infoDaysWeek = aux;
  }

  getMovemenPackageByUser() {
    this.packageMovementArray = [];
    this.dashboardService.getMovemenPackageByUser().subscribe(result => {
      if (result['status']) {

        if (result['infoMovementPackage']) {
          this.packageMovementArray = result['infoMovementPackage'];
          this.packageMovement = new MatTableDataSource(this.packageMovementArray);
        }
      }
    });
  }

  getInfoUserLocker() {
    if (this.roles.includes(this.LOCKER_USER_CODE)) {
      this.getMovemenPackageByUser();
    }
  }

  openModalPictures(ModalPictures, packagePictures) {
    this.packagePictures = packagePictures;
    this.modalService.open(ModalPictures, { size: 'lg' });
  }

  downloadPicture(file_guide) {
    if (file_guide && file_guide.file) {
      this.archivoService.downloadFile(file_guide.file).subscribe((res) => {
        if (res['status'] === true) {
          window.open(res['url'], '_blank');
        }
      });
    }
  }
}
